// extracted by mini-css-extract-plugin
export default {"aside":"SideBar_aside__e-XLu","linkItem":"SideBar_linkItem__Cdck6"};